import { IxDateNext } from './IxDateNext.js';

window.customElements.define('ix-date-next', IxDateNext);
